module.exports = __webpack_public_path__ + "img/15.fb463f3b.png";